import { jwtDecode } from "jwt-decode";

export default function useAuth() {
  const urlToken = new URLSearchParams(window.location.search).get("token");
  const sessionToken = sessionStorage.getItem("access_token");
  const token = urlToken || sessionToken;

  let user = null;

  if (token) {
    try {
      const decoded = jwtDecode(token);

      user = {
        email: decoded.sub || decoded.email || null,
        roles: decoded.roles || [],
        // acessControlconops: decoded.access_control_conops || null,
        acessControlsge: decoded.access_control_sge || [],
        accessOrg: decoded.org_sge || [],
        token: token,
        exp: decoded.exp || null,
      };

    } catch (err) {
      console.error("Invalid token", err);
      user = null;
    }
  }


  return { user };
}
